export function getYoutubeId(url) {
  if (!url) {
    return false;
  }
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/; // eslint-disable-line
  const match = url.match(regExp);
  return (match && match[7].length === 11) ? match[7] : false;
}

export function onClickVideoBlock(event, type, editor) {
  event.preventDefault();
  editor.insertBlock({
    object: 'block',
    type: 'video',
    data: {
      url: '',
    },
  });
}
